import * as React from "react";

const Loader = () => {
  return (
    <div className="lds-roller loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Loader;
